import React from 'react'

const CartCounter = React.createClass({

	getInitialState() {
		return this.props.flux.getStore('cartStore').getState()
	},

	componentWillMount() {
		this.props.flux.getStore('cartStore').listen(this.onChange)
	},

	componentWillUnmount() {
		this.props.flux.getStore('cartStore').unlisten(this.onChange)
	},

	onChange() {
		this.setState(this.getInitialState())
	},

	render() {
		return (
			<span>{this.state.items.length}</span>
		)
	}

})

export default CartCounter


/** WEBPACK FOOTER **
 ** ./src/scripts/components/CartCounter/CartCounter.js
 **/